import React from 'react';

import { Container } from './styles';

const News: React.FC = () => {
  return (
    <Container>
      <span>Assuntos no momento no Brasil</span>
      <strong>Lorem ipsum dolor sit amet.</strong>
    </Container>
  );
}

export default News;